const breakpoint = {
  xs: 444, // 480px
  sm: 600, // 560px
  md: 900, // 640px
  lg: 1200, // 720px
  xl: 1536, // 768px
};
export default breakpoint;
